import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import swal from 'sweetalert';
import { Table, Button, FormGroup } from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';

import {AsyncTypeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../config');


class DespatchForm extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.addComponent = this.addComponent.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.onCancel = this.onCancel.bind(this);


		this.state = {
			date_form : "",
			hour: "",
			health_facilities:[],
			requested_by:"",
			requested_to:"",
			messenger:"",
			user:"",
			user_id:"",
			priority:"",
			observations:"",
			priorities:[{id:"0",name:"Urgente"},{id:"1",name:"24 Horas"}],
			component_list:[],
			unit_number:"",
			component:{},

			requestedSelectedBy:[],
			indiceBy:-1,

			requestedSelectedTo:[],
			indiceTo:-1,

			bloodComponents:[],
			groupRH:[],

			blood_component:"",
			amount:"",
			group_rh:"",

			unitsAdded:[],
			unitsSolicited:[],

			isLoading: false,
			req_by:null,
			req_to:null,
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=DIS_UNIT_CAD&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				dis_unit_cad: response
			});
		})
		
		if (this.props.match.params.id !== -1) {
			//editar

			//traer los datos del pedido
			fetch(Config.default.apiGateway.URL+'unit_request/'+this.props.match.params.id,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			}).then(res => {
		        if(res.ok){
		          return res.json();
		        }else{
		          res.text().then(function(result) {
		            swal('¡Error', result, 'error');
		          });
	        }}).then(response => {
				if(response !== undefined){
					var date = new Date(response.date);

					this.setState({
						requested_by:response.distribuidor,
						requested_to:response.receptor_name,
				      	messenger: response.messenger,
				      	//observations: response.unit_request.observaciones,
				      	hour:response.hour,
				      	date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
				      	priority: response.priority.indexOf('HORAS') !== -1 ? '24 Horas' : 'Urgente',
				      	unitsSolicited:response.detail
				    });

				    this.getHealthFacilities();
				}
			});

			fetch(Config.default.apiGateway.URL+'units_asociation?id='+this.props.match.params.id, {
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res=>{
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal("Error", msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					response.map((r)=>{
						var obj = {}
						obj.unit_id = r.unit.id;
						obj.component_id = r.blood_component.id;
						obj.donation = r.unit.unit_number;
						obj.component = r.blood_component.component;
						obj.component_type = r.blood_component.component_type;
						obj.component_number = r.unit.component_number
						obj.group = r.unit.group;
						obj.rh = r.unit.rh;
						obj.volume = r.unit.volume;
						obj.observations = r.observations;

						this.setState({ 
							unitsAdded: [...this.state.unitsAdded, obj]
						});
					})
				}
			})
		}

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		setTimeout(()=>{
			//obtener usuario
			var user = JSON.parse(sessionStorage.getItem('medical_staff'));

			var name = ""
			if (user.names) {name += user.names};
			if (user.lastname1) {name += ' '+user.lastname1};
			if (user.lastname2) {name += ' '+user.lastname2};

			this.setState({
				user :  name,
				user_id:user.id
			});
			
		}, 500)
	}

	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'health_facilities',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      health_facilities: response
		    });

			//if (this.state.requested_by != "") {
				for (var i = 0; i < response.length; i++) {
					if (response[i].name === this.state.requested_by) {
						this.setState({
							indiceBy:i,
					      	requestedSelectedBy: [response[i]],
					    });

					    this._typeahead_req_by.getInstance().setState({text:response[i].name})
					}else if(response[i].name === this.state.requested_to){
						this.setState({
							indiceTo:i,
					      	requestedSelectedTo: [response[i]],
					    });
					    this._typeahead_req_to.getInstance().setState({text:response[i].name})
					}
				};
			//};
		})
	}

	handleChange(e){
		var campo = e.target.name;

		this.setState({
			[campo] : e.target.value
		});

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}else if(campo === 'unit_number'){
			this.setState({observations:""});
		}
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'component'){
        		if(values[0].status !== 'BLOQUEADA'){
        			this.setState({
			            [name]: values[0],
			            observations:""
			        });
			        
			        document.getElementById('observations').focus();
        		}else{
        			swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
					this._typeahead_component.getInstance().blur();
					this._typeahead_component.getInstance().clear();
					this._typeahead_component.getInstance().focus();
        		}
	        		        	
        	}        	
        }
    }

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			if (e.target.name === "unit_number") {
				fetch(Config.default.apiGateway.URL+'units/send_unit?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+'&unit_number='+e.target.value, {
					method: 'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then(msg=>{
							swal("Error", msg, 'error')
						});

						document.getElementById('unit_number').focus();
					}
				})
				.then(response=>{
					if(response !== undefined){
						this.setState({
							component_list: response
						})
						this._typeahead_component.getInstance().clear();
						this._typeahead_component.getInstance().focus();
					}

				})
			} else if(e.target.name === "observations"){
				this.addComponent();
			};
		}
	}

	/*addComponent(){
		var repeated = false;
		var validComponent = false;

		console.log(this.state)
		if (this.state.unit_number !== "" && this.state.component.unit ) {
			for (var i = 0; i < this.state.unitsAdded.length; i++) {
				if(this.state.unitsAdded[i].unit_id === this.state.component.unit.id &&
					this.state.unitsAdded[i].component_id === this.state.component.blood_component.id){
					repeated = true;
				}
			};

			if (repeated === true) {
				swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
				document.getElementById('unit_number').focus();
				this.setState({ 
					unit_number:"",
					component:{},
					component_list:[],
					observations:"",
				});
				this._typeahead_component.getInstance().clear();
			}else{
				var obj = {}
				obj.unit_id = this.state.component.unit.id;
				obj.component_id = this.state.component.blood_component.id;
				obj.donation = this.state.component.donation_number || this.state.component.unit.unit_number;
				obj.component = this.state.component.blood_component.component;
				obj.component_type = this.state.component.blood_component.component_type;
				obj.group = this.state.component.unit.group;
				obj.rh = this.state.component.unit.rh;
				obj.volume = this.state.component.unit.volume;
				obj.observations = this.state.observations;
				obj.component_number = this.state.component.unit.component_number;
				
				this.setState({ 
					unitsAdded: [...this.state.unitsAdded, obj],
					unit_number:"",
					component:{},
					component_list:[],
					observations:"",
				});

				this._typeahead_component.getInstance().clear();
				document.getElementById('unit_number').focus();
			};	
		} else{
			swal('¡El registro no se puede agregar!', '¡Ingrese unidad valida y componente !', 'error');
			document.getElementById('unit_number').focus();
			this.setState({ 
					unit_number:"",
					component:{},
					component_list:[],
					observations:"",
				});
			this._typeahead_component.getInstance().clear();
		};	
	}*/
	addComponent(){
		var repeated = false;
		var validComponent = false;

		if (this.state.unit_number !== "" && this.state.component.length !== 0 ) {
			var index = this.state.unitsSolicited.findIndex(obj => obj.component_type === this.state.component.blood_component.component_type);
			
			if(index === -1){
				validComponent = true;
			}

			for (var i = 0; i < this.state.unitsAdded.length; i++) {
				if(this.state.unitsAdded[i].unit_id === this.state.component.unit.id &&
					this.state.unitsAdded[i].component_id === this.state.component.blood_component.id){
					repeated = true;
				}
			};

			if(this.state.component.status === 'DISPONIBLE' || this.state.dis_unit_cad.value === 'YES'){
				if (repeated === true) {
					swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
				}else {
					var obj = {}
					obj.unit_id = this.state.component.unit.id;
					obj.component_id = this.state.component.blood_component.id;
					obj.donation = this.state.component.donation_number !== "" ?
									this.state.component.donation_number
								: this.state.component.unit.unit_number;
					obj.component = this.state.component.blood_component.component;
					obj.component_type = this.state.component.blood_component.component_type;
					obj.group = this.state.component.unit.group;
					obj.rh = this.state.component.unit.rh;
					obj.volume = this.state.component.unit.volume;
					obj.component_number = this.state.component.unit.component_number;
					obj.observations = this.state.observations;
					
					this.setState({ 
						unitsAdded: [...this.state.unitsAdded, obj],
						unit_number:"",
						component:{},
						component_list:[],
						observations:""
					});

					this._typeahead_component.getInstance().clear();
					document.getElementById('unit_number').classList.remove('error');
					document.getElementById('unit_number').focus();

				};	
			}else{
				if(this.state.component.status === 'RESERVADA'){
					swal({
						title: '¿Desea retirar la reserva?',
						text: 'No es posible agregar el componente debido a que su estatus es :'+this.state.component.status,
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#DD6B55',
						confirmButtonText: '¡Si, Retirar reserva!',
						cancelButtonText: '¡No, Cancelar!',
						closeOnConfirm: true,
						closeOnCancel: true
					}, (isConfirm)=> {
						if (isConfirm) {
							fetch(Config.default.apiGateway.URL+'unit_reserved/by_unit/'+this.state.component.unit.id,{
								method:'delete',
								headers: new Headers({
									'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
									'Accept'		: 'application/json',
									'Content-Type'	: 'application/json'
								})
							}).then(res => {
								if(res.ok){
									return res.json();
								}else{
									res.text().then((msg)=>{
										swal('Error', msg, 'error');
									});
								}
							}).then(response => {
								var obj = {}
								obj.unit_id = this.state.component.unit.id;
								obj.component_id = this.state.component.blood_component.id;
								obj.donation = this.state.component.donation_number !== "" ?
												this.state.component.donation_number
											: this.state.component.unit.unit_number;
								obj.component = this.state.component.blood_component.component;
								obj.component_type = this.state.component.blood_component.component_type;
								obj.group = this.state.component.unit.group;
								obj.rh = this.state.component.unit.rh;
								obj.volume = this.state.component.unit.volume;
								obj.component_number = this.state.component.unit.component_number;
								
								this.setState({ 
									unitsAdded: [...this.state.unitsAdded, obj],
									unit_number:"",
									component:{},
									component_list:[],
								});

								this._typeahead_component.getInstance().clear();
								document.getElementById('unit_number').classList.remove('error');
								document.getElementById('unit_number').focus();
							});
						}
					});
				}else{
					swal('Error', 'No es posible agregar el componente debido a que su estatus es :'+this.state.component.status, 'error');
				}
				
				
			}

				
		} /*else{
			swal('¡El registro no se puede agregar!', '¡Ingrese unidad y componente !', 'error');
		};	*/
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
	    	if(e.target.name === 'observations'){
				this.addComponent();
			}

      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	removeUnitFromList = (indiceBy) => {
		var array = [...this.state.unitsAdded];
		array.splice(indiceBy, 1);
		this.setState({unitsAdded: array});
	}

	onSave(type){
		if(this.isValidForm()){
			
			if(this.state.unitsAdded.length === 0){
				swal('Error', 'Debe de ingresar al menos una unidad', 'error');
			}else{
				var unit = [];

				for (var i = 0; i < this.state.unitsAdded.length; i++) {
					var index = this.state.unitsSolicited.findIndex(obj => obj.component_type === this.state.unitsAdded[i].component_type)

					unit.push({
						unit_request_id:parseInt(this.props.match.params.id), 
						unit_id:this.state.unitsAdded[i].unit_id,
						observations: this.state.unitsAdded[i].observations
					});
										
				};

				//this.waiting_modal.handleShow('Guardando...');
				var obj = {};
				obj.asociations = unit;
				obj.mensajero = this.state.messenger;
				obj.status = type === 'suministrar' ? 'SUMINISTRADO' : 'ENVIADO';

				
				
				fetch(Config.default.apiGateway.URL+'unit_request/asociation?unit_request_id='+this.props.match.params.id,{
					method:'post',
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res =>{
					this.waiting_modal.handleClose();
					if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(error) {
		                swal('¡Error!', error, 'error');
		              });
		          	}	
				}).then(response=>{
					if(response !== undefined){
						notify.show("Registro guardado correctamente.", 'success');

						if(type === 'suministrar'){
							this.onPrint(this.props.match.params.id);

							setTimeout(()=>{
								this.props.history.push("/shippings");
							}, 1500);
						}else{
							setTimeout(()=>{
								this.props.history.push("/shippings")							//this.props.history.push("/despatch");
							}, 1500);
						}
							
					}
				});
					
			}
				
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	getValidationState(name) {
		const length = this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='requested_by'){
				this.setState({req_by:'error'});
				isFormValid = false;
			}else{
				this.setState({req_to:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='requested_by'){
				this.setState({req_by:''});
			}else{
				this.setState({req_to:''});
			}
		}

		return isFormValid;
	}

	onCancel(){
		this.props.history.push("/shippings");
	}

	onPrint(id){
     	fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
     		sessionStorage.getItem("health_facilities_id")+
     		'&file_type=AREA_DISTRIBUTION&extraction_type=',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	          'Content-Type': 'application/json',
	        })
      	}).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then(function(result) {
                  swal('¡Error', result, 'error');
                });
            }
        }).then(async response => {
        	if(response.res === 0){
          		swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
        	}else{
          		this.props.waiting.handleShow('Imprimiendo...');
          
		        var obj ={};
		        obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		        obj.id = id;
		        obj.file_type = "unit_export_hemored";
		        obj.nEtiqueta = [0];
		        obj.option = 'hemored';

		        var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				}else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				}

				if(document !== undefined){
					this.props.waiting.handleClose();
					this.setState({ show: false});
				}else{
					this.props.waiting.handleClose();
				}
          		
        	}
      	})
  	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						<div>
							{session} ->
							{t('sidebar.nav.home.MAIN')} -> 
							{t('sidebar.nav.distribution.MAIN')} ->
							Despacho de Unidades
						</div>
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12">
						
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2">
								<FormGroup id="req_by" validationState={this.state.req_by || null} style={{marginBottom:"0px"}}>
									<span className="span-min">Centro Distribuidor</span>
									
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"requested_by",
							          		required:true,
							          		readOnly:true,
							          		id:"requested_by"
							          	}}
							          	id="requested_b"
							          	disabled={true}
							          	options={this.state.health_facilities}
							          	onChange={this.handleTypeAheadChange('requested_by')}
							          	defaultSelected={this.state.health_facilities.slice(this.state.indiceBy, 1)}
							          	selected={this.state.requestedSelectedBy}
							          	ref={ref => this._typeahead_req_by = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-2">
								<FormGroup id="req_to" validationState={this.state.req_to || null} style={{marginBottom:"0px"}}>
									<span className="span-min">Centro Peticionario</span>
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"requested_to",
							          		required:true,
							          		readOnly:true,
							          		id:"requested_to"
							          	}}
							          	id="requested_t"
							          	disabled={true}
							          	options={this.state.health_facilities}
							          	onChange={this.handleTypeAheadChange('requested_to')}
							            defaultSelected={this.state.health_facilities.slice(this.state.indiceTo, 1)}
							          	selected={this.state.requestedSelectedTo}
							          	ref={ref => this._typeahead_req_to = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-4">
								<div className="col-xs-12 col-sm-5">
									<span className="span-min">Fecha Petición</span>
									<input className="form-control" name="date_form" id="date_form" type="date" 
										value={this.state.date_form || ""} disabled	onChange={this.handleChange} 
										ref={(input) => { this.inputRef = input }} 
										onKeyPress={(e) => this.validateInput(e)} required />
								</div>
								<div className="col-xs-12 col-sm-3">
									<span className="span-min">Hr Petición</span>
									<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" 
										data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
										value={this.state.hour || ""} onChange={this.handleChange} disabled
										required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
								</div>
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Prioridad</span>
									<select className="form-control" name="priority" id="priority" required disabled
										onChange={this.handleChange} value={this.state.priority || ""} 
										onKeyPress={(e) => this.validateInput(e)}>
										<option value="">Seleccione...</option>
										{this.state.priorities.map((type, i) => (
											<option key={i} value={type.name}>{type.name}</option>
										))

										}
									</select>
								</div>
							</div>

							<div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
								<div className="col-xs-12">
									<span className="span-min">Usuario Envia</span>
									<input className="form-control" disabled name="user" id="user" value={ this.state.user } 
										onChange={ this.handleChange } required/>
								</div>
								
							</div>	

							<div className="col-xs-12 col-sm-2">
								<div className="col-xs-12">
									<span className="span-min">Mensajero</span>
									<input className="form-control" name="messenger" id="messenger"  value={ this.state.messenger || "" } 
										onChange={ this.handleChange } required autoFocus={true} 
										onKeyPress={(e) => this.validateInput(e)} />
								</div>
							</div>
						</div>	

						<fieldset className="col-xs-12">
							<legend>Unidades Solicitadas</legend>

							<div className="col-xs-12 col-sm-10"> 
				              <Table responsive hover style={{margin:"0px"}}>
				                <thead>
				                  <tr>
				                    <th>Componente Sanguineo</th>
				                    <th>Cantidad</th>
				                    <th>Grupo y RH</th>
				                  </tr>
				                </thead>
				                <tbody>
				                 {this.state.unitsSolicited.map( (unit, index) => (
				                    <tr key={index}>
				                      <td>{unit.component}</td>
				                      <td>{unit.amount}</td>
				                      <td>{unit.group+unit.rh} </td>
				                    </tr>
				                  ))}
				                </tbody>
				              </Table>
				            </div>
						</fieldset> 

						<fieldset className="col-xs-12">
							<legend>Unidades</legend>

							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">No. Unidad</span>
									<input type="text" name="unit_number" id="unit_number"  
											onChange={this.handleChange} value={this.state.unit_number || ""} 
											onKeyPress={(e) => this.searchComponent(e)}
											className={"form-control"} />
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">No. Componente</span>
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.label}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"component",
							          		id:"component"
							          	}}
							          	id="component_text"
							          	required={true}
							          	options={this.state.component_list}
							          	onChange={this.handleTypeAheadChange('component')}
							          	onSearch={this._handleSearch}
							          	ref={ref => this._typeahead_component = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>

								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Observaciones</span>
									<input id="observations" name="observations" 
									value={this.state.observations || ""}  
									onChange={this.handleChange} onKeyPress={(e) => this.searchComponent(e)}
									className="form-control"></input>
								</div>

								<div className="col-xs-12 col-sm-1">
									<FloatingActionButton className="action-btn" mini={true} style={{marginTop: 15 }} id="add_button" onClick={this.addComponent}>
				                      <ContentAdd/>
				                    </FloatingActionButton> 
								</div>
							</div>

							<div className="col-xs-12 col-sm-10"> 
				              <Table responsive hover style={{margin:"0px"}}>
				                <thead>
				                  <tr>
				                    <th>No. Donación</th>
				                    <th>Componente Sanguineo</th>
				                    <th>No. Componente</th>
				                    <th>Grupo & RH</th>
				                    <th>Volumen</th>
				                    <th>Observaciones</th>
				                    <th></th>
				                  </tr>
				                </thead>
				                <tbody>
				                 {this.state.unitsAdded.map( (unit, index) => (
				                    <tr key={index}>
				                      <td>{unit.donation}</td>
				                      <td>{unit.component}</td>
				                      <td>{unit.component_number}</td>
				                      <td>{unit.group +(unit.rh === 'POSITIVO' ? '+' : '-')} </td>
				                      <td>{unit.volume}</td>
				                      <td>{unit.observations}</td>
				                      <td width={60} style={{textAlign: "center",padding: "2px",}}>
				                        <Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:'3px'}} onClick={(e) => this.removeUnitFromList(index, e)}>
				                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
				                        </Button>
				                      </td>
				                    </tr>
				                    ))}
				                </tbody>
				              </Table>
				            </div>
						</fieldset> 

				        <hr style={{width:"100%"}}/>
						<div className="col-xs-12" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={"Suministrar"} primary={true} onClick={this.onSave.bind(this, 'suministrar')}  style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave.bind(this, 'guardar')}  style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
				        	</div>
				        </div>
											
					</div>
				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(DespatchForm);
